import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CommonModule, registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NzModalService } from 'ng-zorro-antd/modal';
import { CookieService } from 'ngx-cookie-service';
import { provideTranslateService } from '@ngx-translate/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, TitleStrategy } from '@angular/router';
import { provideEnvironmentNgxMask, NgxMaskConfig } from 'ngx-mask';
import { TitleService } from '@services/title/title.service';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { HttpErrorsInterceptor } from '@interceptors/http-errors/http-errors.interceptor';
import { ApiVersioningInterceptor } from '@interceptors/api-versioning/api-versioning.interceptor';
import { HttpCancelInterceptor } from '@interceptors/http-cancel/http-cancel.interceptor';
import { AuthTokenInterceptor } from '@interceptors/auth-token/auth-token.interceptor';
import { CacheInterceptor } from '@interceptors/cache/cache.interceptor';
import { PaginationResponseInterceptor } from '@interceptors/pagination-response/pagination-response.interceptor';
import { RefreshTokenInterceptor } from '@interceptors/refresh-token/refresh-token.interceptor';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { ServiceWorkerModule } from '@angular/service-worker';
import { APP_INITIALIZER } from '@angular/core';
import {
  AppInitializer,
  appInitializerFactory,
} from '@core/initializers/app.initializer';
import { environment } from '@env/environment';
import { provideNzDateFnsAdapter } from 'ng-zorro-antd/core/time';

// const antDesignIcons = AllIcons as { [key: string]: IconDefinition };
// const icons: IconDefinition[] = Object.keys(antDesignIcons).map(
//   key => antDesignIcons[key]
// );

const maskConfig: Partial<NgxMaskConfig> = { validation: false };
registerLocaleData(en);

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule,
    AppRoutingModule,
    // NzIconModule.forRoot(icons),
    BrowserAnimationsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [
    provideCharts(withDefaultRegisterables()),
    provideEnvironmentNgxMask(maskConfig),
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorsInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshTokenInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpCancelInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiVersioningInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PaginationResponseInterceptor,
      multi: true,
    },
    { provide: TitleStrategy, useClass: TitleService },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [AppInitializer],
      multi: true,
    },
    NzModalService,
    CookieService,
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideNzDateFnsAdapter(),
    ...provideTranslateService(),
    ...provideTranslateHttpLoader(),
  ],
})
export class AppModule {}
